<div class="advertising">
    <div *ngFor="let advertising of advertisings" class="mb-4">
        <img src="{{advertising.image}}" alt="" class="img-fluid">
    </div>
</div>